<template>
  <div class="collect-dispose-container" v-loading="loading">
    <div class="collect-dispose-box">
      <div class="collect-dispose-address">
        <template v-if="!isDeep">
          <el-input class="collect-dispose-address-input" size="mini" v-model="inputUrl"></el-input>
          <el-button class="collect-dispose-address-button" size="mini" type="primary" @click="openUrl">打开网址</el-button>
        </template>
        <template v-if="isDeep">
          <el-input class="collect-dispose-address-input" size="mini" v-model="inputDeepUrl"></el-input>
          <el-button class="collect-dispose-address-button" size="mini" type="primary" @click="openDeepUrl">打开网址</el-button>
        </template>
      </div>
      <div class="collect-dispose-iframe" >
        <iframe v-show="!isDeep" name="collectDisposeIframe" :src="iframeUrl" frameborder="0" width="100%" height="100%"></iframe>
        <iframe v-show="isDeep" name="collectDisposeDeepIframe" :src="iframeDeepUrl" frameborder="0" width="100%" height="100%"></iframe>
        <div class="collect-dispose-iframe-tip" v-show="CollectPluginIsTrue && setKeyType === 'key'"><jee-icon iconClass="caozuoshuoming"></jee-icon>请点击网页列表中的任一个元素</div>
        <div class="collect-dispose-iframe-tip" v-show="CollectPluginIsTrue && setKeyType === 'list'"><jee-icon iconClass="caozuoshuoming"></jee-icon>请点击需要抓取的列表元素 </div>
        <div class="collect-dispose-iframe-tip" v-show="CollectPluginIsTrue && setKeyType === 'page'"><jee-icon iconClass="caozuoshuoming"></jee-icon>请点击正确的分页元素</div>
        <div class="dragLine"  @mousedown='moveDown($event)'></div>
      </div>
      <div class="collect-dispose-table">
        <div class="collect-dispose-table-header">
          <div class="collect-dispose-table-header-right">
            <span v-show="!isDeep" @mousemove="jeeMove('xuanzhejiantou')" @mouseout="jeeOut" @click="selectListKey" :class="{'jee-color': hoverName === 'xuanzhejiantou' }"><jee-icon iconClass="xuanzhejiantou"></jee-icon>选择列表</span>
            <el-popover
              v-show="isManualPage && !isDeep"
              placement="bottom"
              width="400"
              v-model="visible"
              :visible-arrow="false"
              popper-class="popoverBox"
              @show="openVisible"
              :appendToBody='false'
              trigger="click">
              <div class="popoverClose">
                <jee-icon iconClass="tangchuangguanbi" @click="visible = false"></jee-icon>
              </div>
              <div class="popoverPage">
                <div class="popoverPageInput">
                  <div class="popoverPageInputBox">
                    <input type="text" @input="visibleRule" data-key="startPage" placeholder="0" v-model="visibleObj.startPage">
                    <span>-</span><input @input="visibleRule" data-key="endPage" type="text" v-model="visibleObj.endPage" placeholder="0">
                  </div>
                  <div class="popoverPageInputTxt">页</div>
                </div>
                <div class="popoverPageTip">都为“0”表示采集20页</div>
                <div class="popoverPageRadio">
                  <label style="margin-right: 20px;">采集开始点:</label>
                  <el-radio-group v-model="visibleObj.startPoint">
                    <el-radio :label="1">从最新一条开始</el-radio>
                    <el-radio :label="2">从最早一条开始</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div style="text-align: right; margin: 20px 0 0;">
                <el-button size="small" @click="closeVisible" type='default'>取消</el-button>
                <el-button type="primary" size="small" @click="submitVisible">确定</el-button>
              </div>
              <span style="margin-left: 0;" slot="reference" @mousemove="jeeMove('caijiyeshu')" @mouseout="jeeOut" :class="{'jee-color': hoverName === 'caijiyeshu' || collectPagePopover}"><jee-icon iconClass="caijiyeshu"></jee-icon>采集页数</span>
            </el-popover>
            <el-popover v-show="!isDeep" v-model="popoverPage" popper-class="collect-dispose-table-popover table-header" :visible-arrow="false" width="150" :appendToBody='false'>
              <ul>
                <li @click="closeManualPage">不启用分页</li>
                <li @click="openManualPage">手动识别分页</li>
                <li v-show="isManualPage">
                  <el-popover
                    :visible-arrow="false"
                    @show="openPageVisible"
                    placement="left"
                    width="400"
                    popper-class="popoverBox"
                    :appendToBody='false'
                    v-model="pageVisible">
                    <div class="popoverClose">
                      <jee-icon iconClass="tangchuangguanbi" @click="closePageVisible"></jee-icon>
                    </div>
                    <div class="popoverPage">
                      <div class="popoverPageTitle">设置分页XPath，获取下一页按钮的位置</div>
                      <div class="popoverPageTextarea">
                        <el-input v-model="pageVisibleXpath" maxlength="500" type="textarea"></el-input>
                      </div>
                    </div>
                    <div style="text-align: right; margin: 0">
                      <el-button size="small" type="default" @click="closePageVisible">取消</el-button>
                      <el-button type="primary" size="small" @click="submitPageVisible">确定</el-button>
                    </div>
                    <span slot="reference" style='margin-left:0' class='xpath'>设置分页XPath</span>
                  </el-popover>
                </li>
                <li v-show="isManualPage" @click="selectPageKey">选择分页元素</li>
              </ul>
              <span style="margin-left: 0;" slot="reference" @mousemove="jeeMove('fenyeshezhi')" @mouseout="jeeOut" :class="{'jee-color': hoverName === 'fenyeshezhi' }"><jee-icon iconClass="fenyeshezhi"></jee-icon>分页设置</span>
            </el-popover>
            <span v-show="isDeep" @mousemove="jeeMove('caijifanhuiliebiao')" @mouseout="jeeOut" :class="{'jee-color': hoverName === 'caijifanhuiliebiao' }" @click="colseDeepCollect"><jee-icon iconClass="caijifanhuiliebiao"></jee-icon>返回列表</span>
            <span v-show="!isDeep" @mousemove="jeeMove('lianjiexingyinyong')" @mouseout="jeeOut" :class="{'jee-color': hoverName === 'lianjiexingyinyong' }" @click="deepCollect"><jee-icon iconClass="lianjiexingyinyong"></jee-icon>深入链接采集</span>
          </div>
          <div class="collect-dispose-table-header-left">
            <span @mousemove="jeeMove('jia')" @mouseout="jeeOut" @click="addKey" :class="{'jee-color': hoverName === 'jia' }"><jee-icon iconClass="jia"></jee-icon>添加字段</span>
            <span @mousemove="jeeMove('delete')" @mouseout="jeeOut" @click="clearKey" :class="{'jee-color': hoverName === 'delete' }"><jee-icon iconClass="delete"></jee-icon>清空字段</span>
          </div>
        </div>
        <div class="collect-dispose-table-content">
          <el-table :data="tableBodyData" border max-height="320"
            header-cell-class-name="collect-dispose-table-content-header"
            cell-class-name="collect-dispose-table-content-cell">
            <el-table-column type="index" v-if="tableTitleData.length !== 0" width="60" align="center">
              <template slot="header">序号</template>
            </el-table-column>
            <el-table-column :prop="item.prop" min-width="160" :key="item.prop" v-for="(item) in tableTitleData">
              <template slot="header">
                <el-popover popper-class="collect-dispose-table-popover" :visible-arrow="false" width="120">
                  <ul>
                    <li v-if="item.prop !== 'title'" @click="removeKey(item.prop)"><jee-icon iconClass="shanchu"></jee-icon>删除字段</li>
                    <li @click="selectKey(item.prop)"><jee-icon iconClass="xuanzhejiantou"></jee-icon>选择元素</li>
                  </ul>
                  <div slot="reference" class="collect-dispose-table-caret-box">
                    <i class="el-icon-caret-bottom"></i>
                  </div>
                </el-popover>
                {{item.label}}
              </template>
              <template slot-scope="scope">{{ scope.row[item.prop] }}</template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="collect-dispose-button">
      <el-button type="primary" size="mini" @click="startCollect">开始采集</el-button>
      <el-button type="primary" size="mini" @click="saveCollect">仅保存任务</el-button>
    </div>
    <el-dialog
      title="添加字段"
      :visible.sync="addDialogVisible" :class="isAuto?'isAuto':''" ref='addDialog'>
        <div style="padding:0 30px">
        <el-checkbox-group v-model="checkModelFields">
          <el-checkbox :label="item.field" :disabled="item.disabled" v-for="(item, index) in modelFieldList" :key="index"><p>{{item.name}}</p></el-checkbox>
        </el-checkbox-group>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="closeAddKey">取 消</el-button>
          <el-button size="mini" type="primary" @click="addDialogSubmit">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import { deepClone } from '@/utils'
export default {
  name: 'CollectDispose',
  data () {
    return {
      pH: 0,
      CollectPluginIsTrue: false, // 插件是否打开
      pageVisibleXpath: '', // 分页xpath
      listXpath: '', // 选择列表 XPath
      keyXpath: '', // 选择字段 XPath
      keyProp: '', // 选择字段key
      loading: true, // iframe
      hoverName: '', // 选择表格头部文字链接hover效果
      tableTitleData: [], // 表格数据-表头
      tableHeader: [
        {
          prop: 'title',
          label: '标题'
        }
      ], // 列表采集标题
      pageY: 0,
      isDrag: false,
      fieldsList: [],
      collectPagePopover: false,
      isAuto: false,
      tableDeepHeader: [], // 深入采集标题
      tableBodyData: [], // 表格数据-主体数据
      columns: [], // 列表采集数据
      columnsDeep: [], // 深入采集数据
      inputUrl: '', // input输入url
      iframeUrl: '', // iframe跳转url
      inputDeepUrl: '', // 深入采集input地址
      iframeDeepUrl: '', // 深入采集iframe地址
      addDialogVisible: false, // 新增字段是否显示
      checkModelFields: [], // 选中字段
      defaultCheckModel: [], // 默认字段临时保存
      visible: false, // 分页设置
      pageVisible: false, // 手动设置分页
      isManualPage: false, // 是否手动设置分页
      setKeyType: '', // key 字段， list 列表， page 分页
      isDeep: false, // 是否深入采集
      visibleObj: {
        startPage: '0', // 采集结束页数
        endPage: '20', // 采集起始页数
        startPoint: 1 // 采集起点（1从第一条开始，2从最后一条开始）
      }, // 分页数据
      popoverPage: false // 显示分页下拉
    }
  },
  props: ['value', 'customName', 'modelFields', 'collectType'],
  computed: {
    form: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    modelFieldList () {
      let list = deepClone(this.modelField).sort(function () {
        return function (a, b) {
          let value1 = a['name']
          let value2 = b['name']
          return value1 - value2
        }
      })
      return list
    },
    modelField () {
      if (this.fieldsList.length) {
        return this.fieldsList
      } else {
        return this.modelFields
      }
    }
  },
  watch: {
    customName: function (newVal) {
      // 判断是否打开的是采集配置页面, 这是初始链接
      if (newVal === 'dispose') {
        this.inputUrl = this.form.url
        this.iframeUrl = this.form.url
        this.init()
        this.collectAnalysis()
      }
    },
    'visibleObj.endPage': function (newVal) {
    },
    'visible': function (newVal) {
      if (!newVal) {
        this.collectPagePopover = false
      }
    }
  },
  mounted () {
    let _this = this
    window.postMessage({ 'CollectPlugin': true }, '*')
    // 监听页面事件 监听选择的xpath
    window.addEventListener('message', function (e) {
      // 判断插件
      if (e.data.CollectKey && e.data.CollectKey.Key) {
        _this.loading = true
        switch (_this.setKeyType) {
          case 'key':
            _this.keyXpath = e.data.CollectKey.Key
            _this.setKeyType = ''
            if (!_this.isDeep) {
              _this.collectElement()
            } else {
              _this.collectElementDeep()
            }
            break
          case 'list':
            _this.listXpath = e.data.CollectKey.Key
            _this.setKeyType = ''
            _this.collectAnalysis()
            break
          case 'page':
            _this.form.pageXpath = e.data.CollectKey.Key
            _this.setKeyType = ''
            _this.getUrlDynamic()
            break
        }
      }
      // 是否有插件版本
      if (e.data.CollectConfig) {
        _this.CollectPluginIsTrue = true
      }
    }, false)
  },
  methods: {
    // 初始化
    init () {
      this.loading = true
      // 初始化分页设置
      if (this.form.pageSet === 3) {
        this.isManualPage = true
        Object.keys(this.visibleObj).forEach((v) => {
          this.visibleObj[v] = this.form[v]
        })
      }
      // 如果是编辑 初始化字段选中
      if (this.collectType === 'edit') {
        this.defaultCheckModel = []
        this.form.items.forEach(v => {
          this.defaultCheckModel.push(v.itemField)
        })
        this.checkModelFields = deepClone(this.defaultCheckModel)
        this.changeCheckModelFields()
        this.titleHeaderInit()
      }
    },
    // 初始化
    titleHeaderInit () {
      // 默认置空
      this.tableHeader = []
      this.tableDeepHeader = []
      this.form.items.forEach((v) => {
        let obj = {
          isDeep: v.isDeep,
          valueProperty: v.valueProperty,
          dataType: v.dataType,
          prop: v.itemField,
          label: v.name,
          xpath: v.xpath
        }
        if (v.isDeep) {
          this.tableDeepHeader.push(obj)
        } else {
          // 判断是不是 标题
          if (v.itemField === 'title') {
            this.tableHeader.unshift(obj)
          } else {
            this.tableHeader.push(obj)
          }
        }
      })
      this.tableTitleData = deepClone(this.tableHeader)
    },
    // 上下拖动-长按开始
    moveDown (e) {
      let odiv = e.target
      let disY = e.clientY - odiv.offsetTop
      this.isDrag = true
      document.onmousemove = (e) => {
        let top = e.clientY - disY
        if (this.isDrag) {
          document.querySelector('.collect-dispose-iframe').style.height = top + 'px'
        }
      }
      document.onmouseup = (e) => {
        this.isDrag = false
      }
    },
    // 分页input校验
    visibleRule (e) {
      let re = /^(0|\+?[1-9][0-9]*)$/
      if (e.target.value < 0 || e.target.value > 200) {
        this.visibleObj[e.target.dataset.key] = ''
      }
      if (!re.test(e.target.value)) {
        this.visibleObj[e.target.dataset.key] = e.target.value.substr(0, e.target.value.length - 1)
      }
    },
    // 保存分页设置
    submitVisible () {
      if (this.visibleObj.startPage === '') {
        this.visibleObj.startPage = 0
      }

      if (this.visibleObj.endPage === '') {
        this.visibleObj.endPage = 20
      }

      if (this.visibleObj.endPage !== '' && Number(this.visibleObj.endPage) < Number(this.visibleObj.startPage)) {
        this.$message.error('结束分页不能小于开始分页！')
        return
      }
      this.visible = false
      this.collectPagePopover = false
      Object.keys(this.visibleObj).forEach((v) => {
        this.form[v] = this.visibleObj[v]
      })
    },
    // 关闭分页设置
    closeVisible () {
      this.collectPagePopover = false
      this.visible = false
      this.visibleObj = {
        startPoint: 1,
        startPage: '',
        endPage: ''
      }
    },
    // 关闭深入采集
    colseDeepCollect () {
      this.isDeep = false
      // 设置列表采集数据
      this.tableTitleData = deepClone(this.tableHeader)
      this.tableBodyData = deepClone(this.columns)
    },
    // 深入采集
    deepCollect () {
      // 打开第一条url
      let url = ''
      for (let i in this.columns) {
        if (this.columns[i].outLink) {
          url = this.columns[i].outLink
          break
        }
      }
      if (url === '') {
        this.$message.error('未识别到链接地址，无法深入采集')
        return false
      }
      // 设置为深入采集
      this.isDeep = true
      // 设置链接
      this.inputDeepUrl = url
      this.iframeDeepUrl = url
      this.tableTitleData = []
      this.tableBodyData = []
      // 判断是否有深入采集表头
      if (this.tableDeepHeader.length > 0) {
        let fields = this.tableDeepHeader.map(v => {
          let obj = {
            isDeep: v.isDeep,
            itemField: v.prop,
            name: v.label,
            valueProperty: v.valueProperty,
            dataType: v.dataType,
            xpath: v.xpath
          }
          return obj
        })
        this.loading = true
        this.$request.fetchCollectCustomTaskElementForBatch({ 'url': url, 'modelId': this.form.modelId, 'fields': fields }).then(res => {
          this.loading = false
          if (res.code === 200) {
            // 赋值给表格
            this.columnsDeep = res.data.datas === '' ? [] : res.data.datas
            this.tableTitleData = deepClone(this.tableDeepHeader)
            this.tableBodyData = deepClone(this.columnsDeep)
            this.reset()
          }
        })
      }
    },
    // 初始化分页XPath
    openPageVisible () {
      this.pageVisibleXpath = this.form.pageXpath
    },
    // 关闭手动设置分页
    closePageVisible () {
      this.pageVisible = false
      this.pageVisibleXpath = ''
    },
    // 保存手动分页
    submitPageVisible () {
      // 判断是否已经填写了
      if (this.pageVisibleXpath === '') {
        this.$message.error('请填写正确的分页XPath')
        return false
      }
      this.popoverPage = false
      this.pageVisible = false
      this.loading = true
      this.form.pageXpath = this.pageVisibleXpath
      this.getUrlDynamic()
      window.postMessage({ 'pageXpath': this.pageVisibleXpath }, '*')
    },
    // 分页设置显示初始化赋值
    openVisible () {
      this.collectPagePopover = true
      Object.keys(this.form).forEach((v) => {
        this.visibleObj[v] = this.form[v]
      })
    },
    // 打开手动分页
    openManualPage () {
      this.isManualPage = true
      this.form.pageSet = 3
    },
    // 关闭手动分页
    closeManualPage () {
      this.isManualPage = false
      this.form.pageSet = 1
    },
    // 告诉插件 选择列表
    selectListKey () {
      this.setKeyType = 'list'
      window.postMessage({ 'addKey': true }, '*')
    },
    // 告诉插件 选择分页列表
    selectPageKey () {
      this.setKeyType = 'page'
      this.popoverPage = false
      window.postMessage({ 'addKey': true }, '*')
    },
    // 告诉插件 选择元素
    selectKey (key) {
      this.setKeyType = 'key'
      this.keyProp = key
      this.getPopover()
      window.postMessage({ 'addKey': true }, '*')
    },
    // 循环获取弹窗
    getPopover () {
      let tagNames = document.getElementsByTagName('div')
      for (let i in tagNames) {
        for (let k in tagNames[i].attributes) {
          if (tagNames[i].attributes[k].name === 'role' && tagNames[i].attributes[k].value === 'tooltip') {
            tagNames[i].style.display = 'none'
          }
        }
      }
    },
    // 开始采集
    startCollect () {
      let obj = this.RecombinationData()
      // 判断设置分页，是否有分页xpath
      if (obj.task.pageSet === 3 && obj.task.pageXpath === '') {
        this.$message.error('请填写或选择正确的分页XPath')
        return false
      }
      this.loading = true
      if (this.collectType === 'add') {
        this.$request.fetchCollectCustomTaskExtStart(obj).then(res => {
          this.loading = false
          if (res.code === 200) {
            this.goTo('FastCollectLog', { taskId: res.data })
          }
        })
      } else {
        this.$request.fetchCollectCustomTaskExtStartPut(obj).then(res => {
          this.loading = false
          if (res.code === 200) {
            this.goTo('FastCollectLog', { taskId: obj.task.id })
          }
        })
      }
    },
    // 保存
    saveCollect () {
      let obj = this.RecombinationData()
      // 判断设置分页，是否有分页xpath
      if (obj.task.pageSet === 3 && obj.task.pageXpath === '') {
        this.$message.error('请填写或选择正确的分页XPath')
        return false
      }
      this.loading = true
      if (this.collectType === 'add') {
        this.$request.fetchCollectCustomTaskExt(obj).then(res => {
          this.loading = false
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '保存成功',
              onClose: () => {
                this.goHome()
              }
            })
          }
        })
      } else {
        this.$request.fetchCollectCustomTaskExtPut(obj).then(res => {
          this.loading = false
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '保存成功',
              onClose: () => {
                this.goHome()
              }
            })
          }
        })
      }
    },
    // 确认添加字段
    addDialogSubmit () {
      this.addDialogVisible = false
      // 获取当前勾选的index
      let tempIndex = this.modelFieldList.filter((v) => {
        if (this.checkModelFields.indexOf(v.field) !== -1) {
          return v
        }
      }).sort()
      this.changeCheckModelFields()
      // 获取表头数据
      let list = tempIndex.map((v) => {
        let tempText = JSON.stringify(this.tableHeader)
        let tempType = v.dataTyep
        // 判断是否是正文或者单图
        if (v.dataType === 'content') {
          tempType = ''
        }
        if (v.dataType === 'singleImage') {
          tempType = 'href'
        }
        let obj = {
          isDeep: false,
          valueProperty: tempType,
          dataType: v.dataType,
          prop: v.field,
          label: v.name,
          xpath: ''
        }
        // 判断是否是深度采集并且不属于分页列表标题
        if (this.isDeep && tempText.indexOf(obj.prop) === -1) {
          obj.isDeep = true
        }
        return obj
      })
      // 循环赋值
      this.tableTitleData = []
      let tableString = JSON.stringify(this.tableHeader)
      let tableDeepString = JSON.stringify(this.tableDeepHeader)
      for (let i in list) {
        if (list[i].isDeep) {
          if (tableDeepString.indexOf(list[i].prop) === -1) {
            this.tableDeepHeader.push(list[i])
          }
        } else {
          if (tableString.indexOf(list[i].prop) === -1) {
            this.tableHeader.push(list[i])
          }
        }
      }
      // 显示标题
      if (this.isDeep) {
        this.tableTitleData = deepClone(this.tableDeepHeader)
      } else {
        this.tableTitleData = deepClone(this.tableHeader)
      }
      // 赋值给默认字段
      this.defaultCheckModel = deepClone(this.checkModelFields)
    },
    // 关闭添加字段，还原默认值
    closeAddKey () {
      this.addDialogVisible = false
      this.checkModelFields = deepClone(this.defaultCheckModel)
      this.changeCheckModelFields()
    },
    // 添加字段
    addKey () {
      this.addDialogVisible = true
      this.$nextTick(function () {
        var o1 = this.$refs.addDialog.$refs.dialog.offsetHeight
        var a = document.querySelector('.el-dialog__wrapper').offsetHeight * 0.8
        if (o1 > a) {
          this.isAuto = true
        }
      })
    },
    // 删除字段
    removeKey (prop) {
      let index = this.tableTitleData.findIndex((v) => {
        return v.prop === prop
      })
      let checkIndex = this.checkModelFields.findIndex((v) => {
        return v === prop
      })
      // 清除表格数据中的字段
      this.clearTable(this.tableTitleData[index].prop)
      // 删除相对应的数据
      this.checkModelFields.splice(checkIndex, 1)
      this.tableTitleData.splice(index, 1)
      // 判断是否是深入采集
      if (this.isDeep) {
        this.tableDeepHeader.splice(index, 1)
      } else {
        this.tableHeader.splice(index, 1)
      }
      this.changeCheckModelFields()
    },
    // 清除表格数据中的字段
    clearTable (key) {
      if (key) {
        this.tableBodyData.forEach((v) => {
          delete v[key]
          delete v[key + 'XPath']
        })
      } else {
        this.tableBodyData.forEach((v) => {
          for (let i in v) {
            if (i !== 'title' && i !== 'titleXPath' && i !== 'outLink' && i !== 'outLinkXPath') {
              delete v[i]
            }
          }
        })
      }
      // 判断是否是深入采集
      if (!this.isDeep) {
        this.columns = deepClone(this.tableBodyData)
      }
    },
    // 清空除开标题的字段
    clearKey () {
      let _this = this
      let tempObj = this.tableHeader.find((v) => {
        if (v.prop === 'title') {
          return v
        }
      })
      this.tableTitleData = []
      this.checkModelFields = []
      // 判断是否是深入采集
      if (this.isDeep) {
        this.tableDeepHeader = []
      } else {
        this.tableTitleData[0] = tempObj
        this.tableHeader = deepClone(this.tableTitleData)
        this.checkModelFields[0] = tempObj.prop
      }
      // 根据是否是深入采集分别保存相对的选中字段
      this.modelFieldList.forEach((v) => {
        let tempText
        if (_this.isDeep) {
          tempText = JSON.stringify(_this.tableHeader)
        } else {
          tempText = JSON.stringify(_this.tableDeepHeader)
        }
        if (tempText.indexOf(v.field) !== -1) {
          _this.checkModelFields.push(v.field)
        }
      })
      this.changeCheckModelFields()
      // 清除表格数据中的字段
      this.clearTable()
    },
    // change checkModelFields
    changeCheckModelFields () {
      this.fieldsList = this.modelFields.map(a => {
        if (this.checkModelFields.indexOf(a.field) !== -1) {
          return { ...a, disabled: true }
        } else {
          return { ...a }
        }
      })
    },
    reset () {
      this.loading = false
    },
    // 打开网站
    openUrl () {
      this.iframeUrl = this.inputUrl
      this.form.url = this.inputUrl
      // 判断是否是深入采集
      if (!this.isDeep) {
        this.loading = true
        this.collectAnalysis()
      }
    },
    // 打开深度采集网站
    openDeepUrl () {
      this.iframeDeepUrl = this.inputDeepUrl
    },
    // 鼠标移动
    jeeMove (name) {
      this.hoverName = name
    },
    // 鼠标离开
    jeeOut () {
      this.hoverName = ''
    },
    // 采集url分析
    collectAnalysis () {
      let modelId = ''
      if (this.form.modelId instanceof Array) {
        modelId = this.form.modelId[0]
      } else {
        modelId = this.form.modelId
      }
      let obj = {
        url: this.form.url,
        modelId: modelId
      }
      // 判断是否有xpath
      if (this.listXpath !== '') {
        obj.xpath = this.listXpath
      }
      // 判断是否是详情
      if (this.collectType === 'edit') {
        obj.id = this.form.id
      } else {
        // 初始化选中字段
        this.checkModelFields = []
        // 初始化默认选中字段
        this.defaultCheckModel = []
        // 初始化表头
        this.tableHeader = []
        this.tableDeepHeader = []
      }
      this.$request.fetchCollectAnalysisUrl(obj).then(res => {
        if (res.code === 200) {
          if (this.collectType === 'add') {
            // 重置表格表头数据
            let header = res.data.items.map((item) => {
              this.defaultCheckModel.push(item.itemField)
              let obj = {
                isDeep: item.isDeep,
                valueProperty: item.valueProperty,
                dataType: item.dataType,
                prop: item.itemField,
                label: item.name,
                xpath: ''
              }
              return obj
            })
            // 循环赋值
            for (let i in header) {
              if (header[i].prop === 'title') {
                this.tableHeader.unshift(header[i])
              } else {
                this.tableHeader.push(header[i])
              }
            }
            this.checkModelFields = deepClone(this.defaultCheckModel)
            this.changeCheckModelFields()
            this.tableTitleData = deepClone(this.tableHeader)
          }
          // 赋值给表格
          this.columns = res.data.datas
          this.tableBodyData = deepClone(this.columns)
          let xPathData = []
          for (let i = 0; i < this.tableBodyData.length; i++) {
            for (let y in this.tableBodyData[i]) {
              if (y.indexOf('XPath') !== -1) {
                xPathData.push(this.tableBodyData[i][y])
              }
            }
          }
          window.postMessage({ 'xPathData': xPathData }, '*')
          this.reset()
        }
      })
    },
    // 深入采集获取字段XPATH之后，采集数据
    collectElementDeep () {
      let url = this.inputDeepUrl
      let fields = this.tableDeepHeader.map(v => {
        let obj = {
          isDeep: v.isDeep,
          itemField: v.prop,
          name: v.label,
          valueProperty: v.valueProperty,
          dataType: v.dataType,
          xpath: this.keyXpath
        }
        return obj
      })
      this.loading = true
      this.$request.fetchCollectCustomTaskElementForBatch({ 'url': url, 'modelId': this.form.modelId, 'fields': fields }).then(res => {
        this.loading = false
        if (res.code === 200) {
          // 初始化数据
          this.tableTitleData = []
          this.tableBodyData = []
          // 数据表头
          this.tableDeepHeader.forEach((v) => {
            if (v.prop === this.keyProp) {
              v.xpath = this.keyXpath
            }
          })
          // 判断深度采集数据是否为空
          if (this.columnsDeep.length === 0) {
            let obj = {}
            obj[this.keyProp] = res.data.datas[0] ? res.data.datas[0][this.keyProp] : ''
            obj[this.keyProp + 'XPath'] = res.data.datas[0] ? res.data.datas[0][this.keyProp + 'XPath'] : ''
            this.columnsDeep[0] = obj
          } else {
            this.columnsDeep.forEach((v, index) => {
              v[this.keyProp] = res.data.datas[index] ? res.data.datas[index][this.keyProp] : ''
              v[this.keyProp + 'XPath'] = res.data.datas[index] ? res.data.datas[index][this.keyProp + 'XPath'] : ''
            })
          }
          // 赋值
          this.tableTitleData = deepClone(this.tableDeepHeader)
          this.tableBodyData = deepClone(this.columnsDeep)
          this.reset()
        }
      })
    },
    // 获取到字段XPATH之后，采集数据
    collectElement () {
      let obj = {
        url: this.form.url,
        colName: this.keyProp,
        modelId: this.form.modelId,
        xPath: this.keyXpath
      }
      this.$request.fetchCollectCustomTaskListElement(obj).then(res => {
        if (res.code === 200) {
          // 初始化数据
          this.tableTitleData = []
          this.tableBodyData = []
          // 数据表头
          this.tableHeader.forEach((v) => {
            if (v.itemField === this.keyProp) {
              v.xpath = this.keyXpath
            }
          })
          this.columns.forEach((v, index) => {
            v[this.keyProp] = res.data.datas[index] ? res.data.datas[index][this.keyProp] : ''
            v[this.keyProp + 'XPath'] = res.data.datas[index] ? res.data.datas[index][this.keyProp + 'XPath'] : ''
          })
          // 赋值
          this.tableTitleData = deepClone(this.tableHeader)
          this.tableBodyData = deepClone(this.columns)
          this.reset()
        }
      })
    },
    // 重组数据
    RecombinationData () {
      // 合并表头数据
      let headerList = this.tableHeader.concat(this.tableDeepHeader)
      let obj = {
        datas: deepClone(this.columns),
        items: headerList.map((v) => {
          let temp = {
            isDeep: v.isDeep,
            itemField: v.prop,
            valueProperty: v.valueProperty,
            dataType: v.dataType,
            xpath: v.xpath || ''
          }
          return temp
        }),
        task: this.form
      }
      return obj
    },
    // 获取动态地址
    getUrlDynamic () {
      let obj = {
        url: this.form.url,
        colName: 'page',
        modelId: this.form.modelId,
        xPath: this.form.pageXpath,
        valProperty: 'href'
      }
      this.$request.fetchCollectCustomTaskElement(obj).then(res => {
        if (res.code === 200) {
          if (res.data.datas.length === 0) {
            this.$message.error('未检测到正确的分页链接，请选择正确分页元素！')
          } else {
            this.$message({
              message: '已成功识别到分页元素！',
              type: 'success'
            })
            this.form.urlDynamic = res.data.datas[0].page
          }
          this.reset()
        }
      })
    },
    goTo (name, query) {
      query = query || {}
      this.$router.push({ name: name, query: query })
    },
    goHome () {
      this.$router.push({ name: 'index' })
    }
  }
}
</script>

<style scoped lang="scss">
.collect-dispose-container{
  padding-bottom: 30px;
  .collect-dispose-box{
    border-radius: 4px;
    overflow: hidden;
    border-bottom: 1px solid #e8e8e8;
  }

  .dragLine{
    position:absolute;
    height:10px;
    width:100%;
    left:0;
    z-index:5;
    bottom:-10px;
    &:hover{
      cursor:ns-resize;
    }
  }
  .collect-dispose-address{
    display: flex;
    background:rgba(240,240,240,1);
    padding: 10px;
    border: 1px solid #E8E8E8;
    .collect-dispose-address-input{
      flex: 1;
    }
    .collect-dispose-address-button{
      width: 105px;
      margin-left: 10px;
    }
  }
  .collect-dispose-iframe{
    border:1px solid rgba(232,232,232,1);
    width: 100%;
    height: 363px;
    position: relative;
    .collect-dispose-iframe-tip{
      height: 40px;
      line-height: 40px;
      background-color: #FEF2E1;
      font-size: 12px;
      color: #FF9300;
      position: absolute;
      z-index: 22;
      left: 0;
      bottom: 0;
      width: 100%;
      padding: 0 30px;
      .jee-svg-icon{
        color: #FF9300;
        fill: #FF9300;
        font-size: 16px;
        margin-right: 10px;
      }
    }
  }

  .collect-dispose-table{
    .collect-dispose-table-header{
      height:46px;
      line-height: 46px;
      background:rgba(240,240,240,1);
      border-left:1px solid #e8e8e8;
      border-right:1px solid #e8e8e8;
      border-bottom:1px solid #e8e8e8;
      padding: 0 20px;
      span{
        display: inline-block;
        margin-right: 40px;
        color:rgba(102,102,102,1);
        font-size:14px;
        cursor: pointer;
        .jee-svg-icon{
          margin-right: 10px;
          font-size: 14px;
          fill: rgba(102,102,102,1);
          color: rgba(102,102,102,1);
        }
      }
      .collect-dispose-table-header-right{
        float: right;
        text-align: right;
        span{
          margin-right: 0;
          margin-left: 40px;
          &:focus{
            outline-color: transparent;
          }
        }
      }
    }
    /deep/ .el-table__header th.collect-dispose-table-content-header{
      height:40px!important;
      padding: 0;
      background:rgba(249,249,249,1);
      font-size:14px;
      color: #666;
      &:first-of-type{
        padding-left: 0!important;
      }
      .cell{
        height: 26px;
      }
    }
    /deep/ .el-table__row td.collect-dispose-table-content-cell{
      height:40px;
      padding: 0;
      &:first-of-type{
        padding-left: 0!important;
      }
      .cell{
        white-space: nowrap;
      }
    }
    /deep/ .el-table{
      border: none;
      border-left: 1px solid #e8e8e8;
      border-radius: unset;
    }
    .collect-dispose-table-caret-box{
      float: right;
      width:26px;
      height:26px;
      text-align: center;
      line-height: 23px;
      background:#F0F0F0;
      border:1px solid #E8E8E8;
      border-radius:4px;
      padding: 0;
      cursor: pointer;
      &:hover{
        border-color: #C0C4CC;
      }
    }
  }
  .collect-dispose-button{
    margin-top: 20px;
    /deep/ .el-button {
      height: 32px;
      padding: 0 20px;
    }
  }
}
</style>
<style lang="scss">
.collect-dispose-table-popover{
  min-width: auto!important;
  padding: 5px 0!important;
  border: 1px solid #1EC6DF!important;
  .xpath{
    &:hover{
      color:#1ec6df !important;
    }
  }
  li{
    font-size: 14px;
    color: #666666;
    height:34px;
    line-height: 34px;
    cursor: pointer;
    text-align: center;
    >span{
      margin-left:0!important;
    }
    .jee-svg-icon{
      font-size: 13px;
      margin-right: 10px;
      color: #666;
      fill: #666;
    }
    &:hover{
      background-color: #F3F3F3;
      color: #1EC6DF;
      .jee-svg-icon{
        color: #1EC6DF;
        fill: #1EC6DF;
      }
    }
  }
  &.table-header {
    margin-top: 0!important;
    li{
      text-align: left;
      padding: 0 20px;
    }
  }
}

.popoverBox{
  padding: 30px!important;
  margin-top: 0!important;
  .popoverClose{
    text-align: right;
    .jee-svg-icon{
      font-size: 14px;
      color: #999;
      fill: #999;
      cursor: pointer;
    }
  }
  .popoverPage{
    .popoverPageInput{
      display: flex;
      margin-bottom: 10px;
      align-items: center;
      .popoverPageInputBox{
        width: 140px;
        line-height: 32px;
        border: 1px solid #EDEDED;
        border-radius: 5px;
        text-align: center;
        display: flex;
        overflow: hidden;
        input{
          border: none;
          width: 50px;
          text-align: center;
          &:focus{
            outline-color: transparent;
          }
        }
        span{
          flex: 1;
          padding: 0 10px;
          display: inline-block;
          margin-left:0 !important;
        }
      }
      .popoverPageInputTxt{
        flex: 1;
        padding-left: 20px;
        color: #666;
      }
    }
    .popoverPageTip{
      font-size:12px;
      color: #B3B3B3;
      margin-bottom: 15px;
    }
    .popoverPageRadio{
      color: #333;
      font-weight: bold;
      label{
        font-weight: normal;
        font-size: 14px;
        color: #666;
      }
    }
    .popoverPageTitle{
      font-size: 14px;
      color: #666666;
      line-height: 30px;
    }
    .popoverPageTextarea{
      margin-bottom: 30px;
    }
  }
}
.collect-dispose-container{
  .el-dialog__wrapper{
    .el-dialog{
      width: auto!important;
      .el-dialog__body{
        padding:0;
        overflow-y:hidden;
        max-height:300px;
        .el-checkbox-group{
          display: grid;
          grid-template-columns: auto auto auto auto;
          .el-checkbox{
            margin-right: 102px;
            padding-bottom: 20px;
          }
          span.el-checkbox__label{
            display: flex;
            >p{
              margin-top: -2px;
              max-width: 130px;
              display: inline;
              word-break: break-all;
              word-wrap: break-word;
              white-space:pre-wrap;
              line-height: 1.4;
              cursor: pointer;
            }
          }
          .el-checkbox__input.is-disabled + span.el-checkbox__label{
            >p{
              cursor: not-allowed;
            }
          }
        }
      }
    }
    .el-dialog.isAuto{
      .el-dialog__body{
        overflow-y: overlay !important;
      }
    }
  }
}
</style>
